'use client';

import React, { createContext } from 'react';
import { PlatformPrimitives } from '../types/PlatformPrimitives';
import { WebDefaults } from '../constants/WebDefaults';

/**
 * @group Context

@summary
<blockquote>React context for providing platform primitives to universal components.</blockquote>

@example
```typescript
const PlatformContext = createContext<PlatformPrimitives>(WebDefaults);
```
 * @internal
 */
export const PlatformContext = createContext<PlatformPrimitives>(WebDefaults); 